module.exports = __webpack_public_path__ + "img/edc-BNI.e5101806.png";